import React from "react";

// Bordered white card with an icon + title (+ optional subtitle) header row,
// used as the standard section container across every Agent Program screen
// (lifted from AppBuildManager's "Publish New Build" card).
export default function SectionCard({ icon: Icon, title, subtitle, headerRight, children, bodyClassName = "p-6" }) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
      {(title || Icon) && (
        <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between gap-3">
          <div className="flex items-center gap-2.5 min-w-0">
            {Icon && <Icon size={17} className="text-gray-400 flex-shrink-0" />}
            <div className="min-w-0">
              {title && <h3 className="text-sm font-semibold text-gray-800 truncate">{title}</h3>}
              {subtitle && <p className="text-xs text-gray-400 mt-0.5">{subtitle}</p>}
            </div>
          </div>
          {headerRight && <div className="flex-shrink-0">{headerRight}</div>}
        </div>
      )}
      <div className={bodyClassName}>{children}</div>
    </div>
  );
}
